import React from "react";
import MobileSignUpForm from "../components/SignUp/MobileSignUpForm";

const SignUp = () => {
  return (
    <>
      <div className="flex items-center justify-center text-[#454545] font-['Roboto',sans-serif] h-screen bg-gradient-to-br from-[#1569AB] via-[#1569AB] to-[#1E8C45]">
        <MobileSignUpForm />
      </div>
    </>
  );
};

export default SignUp;
